import { createContext, useContext } from "react";
import type { SessionTimeouts } from "@/api/generated/auth";

/** Same defaults as the backend (.env.example), used until GET /auth/session answers. */
export const DEFAULT_TIMEOUTS: SessionTimeouts = {
  idleSeconds: 600,
  promptTimeoutSeconds: 120,
  recordingMaxSeconds: 4 * 60 * 60,
  silencePromptSeconds: 600,
  warningSeconds: 60,
};

export const SessionTimeoutsContext =
  createContext<SessionTimeouts>(DEFAULT_TIMEOUTS);

/** Timeouts of the session (shared-device logout, "Noch da?" prompt). */
export function useSessionTimeouts(): SessionTimeouts {
  return useContext(SessionTimeoutsContext);
}
